const formatter = new Intl.NumberFormat('ru-RU', {
  style: 'currency',
  currency: 'RUB',
});

export function formatCurrency(value: number): string {
  return formatter.format(value);
}
